import * as z from "zod";

const OMSMetricsRequestSchema_ = z.object({
  startDate: z.date(),
  endDate: z.date(),
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});
export const OMSMetricsRequestSchema: z.ZodType<OMSMetricsRequest> =
  OMSMetricsRequestSchema_;
export interface OMSMetricsRequest extends z.infer<
  typeof OMSMetricsRequestSchema_
> {}

const OMSMetricsResponseSchema_ = z.object({ value: z.number() });
export const OMSMetricsResponseSchema: z.ZodType<OMSMetricsResponse> =
  OMSMetricsResponseSchema_;
export interface OMSMetricsResponse extends z.infer<
  typeof OMSMetricsResponseSchema_
> {}

const CarrierShipmentCountSchema_ = z.object({
  carrier: z.string(),
  count: z.number(),
});
export const CarrierShipmentCountSchema: z.ZodType<CarrierShipmentCount> =
  CarrierShipmentCountSchema_;
export interface CarrierShipmentCount extends z.infer<
  typeof CarrierShipmentCountSchema_
> {}

const ShipmentsByCarrierResponseSchema_ = z.object({
  carriers: z.array(CarrierShipmentCountSchema),
});
export const ShipmentsByCarrierResponseSchema: z.ZodType<ShipmentsByCarrierResponse> =
  ShipmentsByCarrierResponseSchema_;
export interface ShipmentsByCarrierResponse extends z.infer<
  typeof ShipmentsByCarrierResponseSchema_
> {}

export const timeGrain = ["daily", "weekly", "monthly"] as const;
export type TimeGrain = (typeof timeGrain)[number];
export const TimeGrainSchema = z.enum(timeGrain);

const CarrierVolumeOverTimeRequestSchema_ = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});
export const CarrierVolumeOverTimeRequestSchema: z.ZodType<CarrierVolumeOverTimeRequest> =
  CarrierVolumeOverTimeRequestSchema_;
export interface CarrierVolumeOverTimeRequest extends z.infer<
  typeof CarrierVolumeOverTimeRequestSchema_
> {}

const CarrierVolumeByPeriodSchema_ = z.object({
  period: z.string(),
  carriers: z.array(CarrierShipmentCountSchema),
});
export const CarrierVolumeByPeriodSchema: z.ZodType<CarrierVolumeByPeriod> =
  CarrierVolumeByPeriodSchema_;
export interface CarrierVolumeByPeriod extends z.infer<
  typeof CarrierVolumeByPeriodSchema_
> {}

const CarrierVolumeOverTimeResponseSchema_ = z.object({
  data: z.array(CarrierVolumeByPeriodSchema),
});
export const CarrierVolumeOverTimeResponseSchema: z.ZodType<CarrierVolumeOverTimeResponse> =
  CarrierVolumeOverTimeResponseSchema_;
export interface CarrierVolumeOverTimeResponse extends z.infer<
  typeof CarrierVolumeOverTimeResponseSchema_
> {}

const FulfillmentCountByDateSchema_ = z.object({
  date: z.string(),
  count: z.number(),
});
export const FulfillmentCountByDateSchema: z.ZodType<FulfillmentCountByDate> =
  FulfillmentCountByDateSchema_;
export interface FulfillmentCountByDate extends z.infer<
  typeof FulfillmentCountByDateSchema_
> {}

const FulfillmentsOverTimeRequestSchema_ = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});
export const FulfillmentsOverTimeRequestSchema: z.ZodType<FulfillmentsOverTimeRequest> =
  FulfillmentsOverTimeRequestSchema_;
export interface FulfillmentsOverTimeRequest extends z.infer<
  typeof FulfillmentsOverTimeRequestSchema_
> {}

const FulfillmentsOverTimeResponseSchema_ = z.object({
  data: z.array(FulfillmentCountByDateSchema),
});
export const FulfillmentsOverTimeResponseSchema: z.ZodType<FulfillmentsOverTimeResponse> =
  FulfillmentsOverTimeResponseSchema_;
export interface FulfillmentsOverTimeResponse extends z.infer<
  typeof FulfillmentsOverTimeResponseSchema_
> {}

const DateValueSchema_ = z.object({ date: z.string(), value: z.number() });
export const DateValueSchema: z.ZodType<DateValue> = DateValueSchema_;
export interface DateValue extends z.infer<typeof DateValueSchema_> {}

const AvgDaysToFulfillOverTimeRequestSchema_ = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});
export const AvgDaysToFulfillOverTimeRequestSchema: z.ZodType<AvgDaysToFulfillOverTimeRequest> =
  AvgDaysToFulfillOverTimeRequestSchema_;
export interface AvgDaysToFulfillOverTimeRequest extends z.infer<
  typeof AvgDaysToFulfillOverTimeRequestSchema_
> {}

const AvgDaysToFulfillOverTimeResponseSchema_ = z.object({
  data: z.array(DateValueSchema),
});
export const AvgDaysToFulfillOverTimeResponseSchema: z.ZodType<AvgDaysToFulfillOverTimeResponse> =
  AvgDaysToFulfillOverTimeResponseSchema_;
export interface AvgDaysToFulfillOverTimeResponse extends z.infer<
  typeof AvgDaysToFulfillOverTimeResponseSchema_
> {}

const CarrierAvgDeliveryTimeSchema_ = z.object({
  carrier: z.string(),
  avgDaysToDeliver: z.number(),
});
export const CarrierAvgDeliveryTimeSchema: z.ZodType<CarrierAvgDeliveryTime> =
  CarrierAvgDeliveryTimeSchema_;
export interface CarrierAvgDeliveryTime extends z.infer<
  typeof CarrierAvgDeliveryTimeSchema_
> {}

const AvgTimeToDeliverByCarrierResponseSchema_ = z.object({
  carriers: z.array(CarrierAvgDeliveryTimeSchema),
});
export const AvgTimeToDeliverByCarrierResponseSchema: z.ZodType<AvgTimeToDeliverByCarrierResponse> =
  AvgTimeToDeliverByCarrierResponseSchema_;
export interface AvgTimeToDeliverByCarrierResponse extends z.infer<
  typeof AvgTimeToDeliverByCarrierResponseSchema_
> {}

const ServiceLevelAvgDeliveryTimeSchema_ = z.object({
  serviceLevel: z.string(),
  avgDaysToDeliver: z.number(),
});
export const ServiceLevelAvgDeliveryTimeSchema: z.ZodType<ServiceLevelAvgDeliveryTime> =
  ServiceLevelAvgDeliveryTimeSchema_;
export interface ServiceLevelAvgDeliveryTime extends z.infer<
  typeof ServiceLevelAvgDeliveryTimeSchema_
> {}

const AvgTimeToDeliverByServiceLevelResponseSchema_ = z.object({
  serviceLevels: z.array(ServiceLevelAvgDeliveryTimeSchema),
});
export const AvgTimeToDeliverByServiceLevelResponseSchema: z.ZodType<AvgTimeToDeliverByServiceLevelResponse> =
  AvgTimeToDeliverByServiceLevelResponseSchema_;
export interface AvgTimeToDeliverByServiceLevelResponse extends z.infer<
  typeof AvgTimeToDeliverByServiceLevelResponseSchema_
> {}

const CarrierSpendSchema_ = z.object({
  carrier: z.string(),
  totalCost: z.number(),
});
export const CarrierSpendSchema: z.ZodType<CarrierSpend> = CarrierSpendSchema_;
export interface CarrierSpend extends z.infer<typeof CarrierSpendSchema_> {}

const CarrierSpendByPeriodSchema_ = z.object({
  period: z.string(),
  carriers: z.array(CarrierSpendSchema),
});
export const CarrierSpendByPeriodSchema: z.ZodType<CarrierSpendByPeriod> =
  CarrierSpendByPeriodSchema_;
export interface CarrierSpendByPeriod extends z.infer<
  typeof CarrierSpendByPeriodSchema_
> {}

const CarrierSpendOverTimeRequestSchema_ = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});
export const CarrierSpendOverTimeRequestSchema: z.ZodType<CarrierSpendOverTimeRequest> =
  CarrierSpendOverTimeRequestSchema_;
export interface CarrierSpendOverTimeRequest extends z.infer<
  typeof CarrierSpendOverTimeRequestSchema_
> {}

const CarrierSpendOverTimeResponseSchema_ = z.object({
  data: z.array(CarrierSpendByPeriodSchema),
});
export const CarrierSpendOverTimeResponseSchema: z.ZodType<CarrierSpendOverTimeResponse> =
  CarrierSpendOverTimeResponseSchema_;
export interface CarrierSpendOverTimeResponse extends z.infer<
  typeof CarrierSpendOverTimeResponseSchema_
> {}

const SpendByCarrierResponseSchema_ = z.object({
  carriers: z.array(CarrierSpendSchema),
});
export const SpendByCarrierResponseSchema: z.ZodType<SpendByCarrierResponse> =
  SpendByCarrierResponseSchema_;
export interface SpendByCarrierResponse extends z.infer<
  typeof SpendByCarrierResponseSchema_
> {}

const CarrierTotalAdjustmentSchema_ = z.object({
  carrier: z.string(),
  totalAdjustment: z.number(),
});
export const CarrierTotalAdjustmentSchema: z.ZodType<CarrierTotalAdjustment> =
  CarrierTotalAdjustmentSchema_;
export interface CarrierTotalAdjustment extends z.infer<
  typeof CarrierTotalAdjustmentSchema_
> {}

const TotalAdjustmentByCarrierResponseSchema_ = z.object({
  carriers: z.array(CarrierTotalAdjustmentSchema),
});
export const TotalAdjustmentByCarrierResponseSchema: z.ZodType<TotalAdjustmentByCarrierResponse> =
  TotalAdjustmentByCarrierResponseSchema_;
export interface TotalAdjustmentByCarrierResponse extends z.infer<
  typeof TotalAdjustmentByCarrierResponseSchema_
> {}

const CarrierSurchargeSchema_ = z.object({
  carrier: z.string(),
  totalSurchargeAmount: z.number(),
  surchargeCount: z.number(),
});
export const CarrierSurchargeSchema: z.ZodType<CarrierSurcharge> =
  CarrierSurchargeSchema_;
export interface CarrierSurcharge extends z.infer<
  typeof CarrierSurchargeSchema_
> {}

const CarrierSurchargeByPeriodSchema_ = z.object({
  period: z.string(),
  carriers: z.array(CarrierSurchargeSchema),
});
export const CarrierSurchargeByPeriodSchema: z.ZodType<CarrierSurchargeByPeriod> =
  CarrierSurchargeByPeriodSchema_;
export interface CarrierSurchargeByPeriod extends z.infer<
  typeof CarrierSurchargeByPeriodSchema_
> {}

const CarrierSurchargesOverTimeRequestSchema_ = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});
export const CarrierSurchargesOverTimeRequestSchema: z.ZodType<CarrierSurchargesOverTimeRequest> =
  CarrierSurchargesOverTimeRequestSchema_;
export interface CarrierSurchargesOverTimeRequest extends z.infer<
  typeof CarrierSurchargesOverTimeRequestSchema_
> {}

const CarrierSurchargesOverTimeResponseSchema_ = z.object({
  data: z.array(CarrierSurchargeByPeriodSchema),
});
export const CarrierSurchargesOverTimeResponseSchema: z.ZodType<CarrierSurchargesOverTimeResponse> =
  CarrierSurchargesOverTimeResponseSchema_;
export interface CarrierSurchargesOverTimeResponse extends z.infer<
  typeof CarrierSurchargesOverTimeResponseSchema_
> {}

const CarrierAvgLabelCostSchema_ = z.object({
  carrier: z.string(),
  avgLabelCost: z.number(),
});
export const CarrierAvgLabelCostSchema: z.ZodType<CarrierAvgLabelCost> =
  CarrierAvgLabelCostSchema_;
export interface CarrierAvgLabelCost extends z.infer<
  typeof CarrierAvgLabelCostSchema_
> {}

const AvgLabelCostByCarrierResponseSchema_ = z.object({
  carriers: z.array(CarrierAvgLabelCostSchema),
});
export const AvgLabelCostByCarrierResponseSchema: z.ZodType<AvgLabelCostByCarrierResponse> =
  AvgLabelCostByCarrierResponseSchema_;
export interface AvgLabelCostByCarrierResponse extends z.infer<
  typeof AvgLabelCostByCarrierResponseSchema_
> {}

const CarrierAvgAdjustmentSchema_ = z.object({
  carrier: z.string(),
  avgAdjustment: z.number(),
});
export const CarrierAvgAdjustmentSchema: z.ZodType<CarrierAvgAdjustment> =
  CarrierAvgAdjustmentSchema_;
export interface CarrierAvgAdjustment extends z.infer<
  typeof CarrierAvgAdjustmentSchema_
> {}

const AvgAdjustmentByCarrierResponseSchema_ = z.object({
  carriers: z.array(CarrierAvgAdjustmentSchema),
});
export const AvgAdjustmentByCarrierResponseSchema: z.ZodType<AvgAdjustmentByCarrierResponse> =
  AvgAdjustmentByCarrierResponseSchema_;
export interface AvgAdjustmentByCarrierResponse extends z.infer<
  typeof AvgAdjustmentByCarrierResponseSchema_
> {}

const ServiceLevelShipmentCountSchema_ = z.object({
  serviceLevel: z.string(),
  count: z.number(),
});
export const ServiceLevelShipmentCountSchema: z.ZodType<ServiceLevelShipmentCount> =
  ServiceLevelShipmentCountSchema_;
export interface ServiceLevelShipmentCount extends z.infer<
  typeof ServiceLevelShipmentCountSchema_
> {}

const ServiceLevelVolumeByPeriodSchema_ = z.object({
  period: z.string(),
  serviceLevels: z.array(ServiceLevelShipmentCountSchema),
});
export const ServiceLevelVolumeByPeriodSchema: z.ZodType<ServiceLevelVolumeByPeriod> =
  ServiceLevelVolumeByPeriodSchema_;
export interface ServiceLevelVolumeByPeriod extends z.infer<
  typeof ServiceLevelVolumeByPeriodSchema_
> {}

const ServiceLevelVolumeOverTimeRequestSchema_ = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});
export const ServiceLevelVolumeOverTimeRequestSchema: z.ZodType<ServiceLevelVolumeOverTimeRequest> =
  ServiceLevelVolumeOverTimeRequestSchema_;
export interface ServiceLevelVolumeOverTimeRequest extends z.infer<
  typeof ServiceLevelVolumeOverTimeRequestSchema_
> {}

const ServiceLevelVolumeOverTimeResponseSchema_ = z.object({
  data: z.array(ServiceLevelVolumeByPeriodSchema),
});
export const ServiceLevelVolumeOverTimeResponseSchema: z.ZodType<ServiceLevelVolumeOverTimeResponse> =
  ServiceLevelVolumeOverTimeResponseSchema_;
export interface ServiceLevelVolumeOverTimeResponse extends z.infer<
  typeof ServiceLevelVolumeOverTimeResponseSchema_
> {}

const ServiceLevelShippingMarginSchema_ = z.object({
  serviceLevel: z.string(),
  shippingMargin: z.number(),
});
export const ServiceLevelShippingMarginSchema: z.ZodType<ServiceLevelShippingMargin> =
  ServiceLevelShippingMarginSchema_;
export interface ServiceLevelShippingMargin extends z.infer<
  typeof ServiceLevelShippingMarginSchema_
> {}

const ServiceLevelShippingMarginByPeriodSchema_ = z.object({
  period: z.string(),
  serviceLevels: z.array(ServiceLevelShippingMarginSchema),
});
export const ServiceLevelShippingMarginByPeriodSchema: z.ZodType<ServiceLevelShippingMarginByPeriod> =
  ServiceLevelShippingMarginByPeriodSchema_;
export interface ServiceLevelShippingMarginByPeriod extends z.infer<
  typeof ServiceLevelShippingMarginByPeriodSchema_
> {}

const ServiceLevelShippingMarginOverTimeRequestSchema_ = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});
export const ServiceLevelShippingMarginOverTimeRequestSchema: z.ZodType<ServiceLevelShippingMarginOverTimeRequest> =
  ServiceLevelShippingMarginOverTimeRequestSchema_;
export interface ServiceLevelShippingMarginOverTimeRequest extends z.infer<
  typeof ServiceLevelShippingMarginOverTimeRequestSchema_
> {}

const ServiceLevelShippingMarginOverTimeResponseSchema_ = z.object({
  data: z.array(ServiceLevelShippingMarginByPeriodSchema),
});
export const ServiceLevelShippingMarginOverTimeResponseSchema: z.ZodType<ServiceLevelShippingMarginOverTimeResponse> =
  ServiceLevelShippingMarginOverTimeResponseSchema_;
export interface ServiceLevelShippingMarginOverTimeResponse extends z.infer<
  typeof ServiceLevelShippingMarginOverTimeResponseSchema_
> {}

const ShippingMarginByPeriodSchema_ = z.object({
  period: z.string(),
  shippingMargin: z.number(),
});
export const ShippingMarginByPeriodSchema: z.ZodType<ShippingMarginByPeriod> =
  ShippingMarginByPeriodSchema_;
export interface ShippingMarginByPeriod extends z.infer<
  typeof ShippingMarginByPeriodSchema_
> {}

const ShippingMarginOverTimeRequestSchema_ = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
  canonicalLocationExternalId: z.string().optional(),
});
export const ShippingMarginOverTimeRequestSchema: z.ZodType<ShippingMarginOverTimeRequest> =
  ShippingMarginOverTimeRequestSchema_;
export interface ShippingMarginOverTimeRequest extends z.infer<
  typeof ShippingMarginOverTimeRequestSchema_
> {}

const ShippingMarginOverTimeResponseSchema_ = z.object({
  data: z.array(ShippingMarginByPeriodSchema),
});
export const ShippingMarginOverTimeResponseSchema: z.ZodType<ShippingMarginOverTimeResponse> =
  ShippingMarginOverTimeResponseSchema_;
export interface ShippingMarginOverTimeResponse extends z.infer<
  typeof ShippingMarginOverTimeResponseSchema_
> {}

const SurchargeDescriptionSchema_ = z.object({
  description: z.string(),
  amount: z.number(),
});
export const SurchargeDescriptionSchema: z.ZodType<SurchargeDescription> =
  SurchargeDescriptionSchema_;
export interface SurchargeDescription extends z.infer<
  typeof SurchargeDescriptionSchema_
> {}

const SurchargeByCategorySchema_ = z.object({
  category: z.string(),
  totalAmount: z.number(),
  surchargeCount: z.number(),
  descriptions: z.array(SurchargeDescriptionSchema),
});
export const SurchargeByCategorySchema: z.ZodType<SurchargeByCategory> =
  SurchargeByCategorySchema_;
export interface SurchargeByCategory extends z.infer<
  typeof SurchargeByCategorySchema_
> {}

const SurchargeByCategoryResponseSchema_ = z.object({
  categories: z.array(SurchargeByCategorySchema),
});
export const SurchargeByCategoryResponseSchema: z.ZodType<SurchargeByCategoryResponse> =
  SurchargeByCategoryResponseSchema_;
export interface SurchargeByCategoryResponse extends z.infer<
  typeof SurchargeByCategoryResponseSchema_
> {}
